import React, { useEffect } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Destinations from '../components/Destinations';
import Airlines from '../components/Airlines';
import Services from '../components/Services';
import Payments from '../components/Payments';
import BookingForm from '../components/BookingForm';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Testimonials from '../components/Testimonials';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HomePage = () => {
  useEffect(() => {
    if (!sessionStorage.getItem('izi_visit_tracked')) {
      axios.post(`${API}/visits`).catch(() => {});
      sessionStorage.setItem('izi_visit_tracked', '1');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Destinations />
      <Airlines />
      <Services />
      <Payments />
      <BookingForm />
      <Contact />
      <About />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default HomePage;
